import { Colors } from "@/enums/Colors";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { ConversationTypePath } from "@/types/ConversationType";
import { Typography } from "@mui/material";
import { CSSProperties } from "react";
import LazoNoLetters from "../../../assets/images/chat-bot-avatar-image.svg";
import UserAvatar from "./Avatar";

const avatarContainer: CSSProperties = {
  padding: "0.5rem 0.5rem 0.5rem 0",
};

const avatarStyle: CSSProperties = {
  textTransform: "none",
  overflow: "hidden",
  borderRadius: "50%",
  width: "2rem",
  height: "2rem",
  objectFit: "cover",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: Colors.LAZO_PURPLE,
  backgroundImage: `linear-gradient(160deg, ${Colors.STONE_OCEAN_BLUE}, transparent)`,
  color: "#fff",
  fontSize: "1.3rem",
};

interface ChatMessageContainerProps {
  isBotMessage?: boolean;
  user: User;
  userAvatarStyle?: CSSProperties;
  messageDateGroup?: string;
  disableImage?: boolean;
  disableName?: boolean;
}

function ChatAvatar({ isBotMessage, user, userAvatarStyle, messageDateGroup, disableImage, disableName }: ChatMessageContainerProps) {
  return (
    <>
      <div style={avatarContainer}>
        {isBotMessage ? (
          <>
            <div style={{ ...CommonUserAvatarStyle }}>
              <div style={{ ...avatarStyle, marginRight: "1rem" }}>
                <img alt={"lazo-no-letters-avatar"} src={LazoNoLetters.src} height={"100%"} width={"100%"} />
              </div>
              <Typography style={{ fontWeight: 600, color: Colors.LAZO_PURPLE }}>
                Lazo AI / {ConversationTypePath.find((ctp) => location.pathname.includes(ctp.path))?.render || ""}
              </Typography>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                ...CommonUserAvatarStyle,
                ...userAvatarStyle,
              }}
            >
              {!disableImage && <UserAvatar sx={{ marginRight: "1rem" }} user={user} />}
              {!disableName && (
                <Typography style={{ fontWeight: 600, marginRight: "1rem" }}>{user.firstName + " " + user.lastName}</Typography>
              )}
              {messageDateGroup && <Typography sx={{ fontSize: "0.8rem" }}>{messageDateGroup}</Typography>}
            </div>
          </>
        )}
      </div>
    </>
  );
}

const CommonUserAvatarStyle: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  borderRadius: "100%",
};

export default ChatAvatar;
